import { Component, Vue, Prop} from 'vue-property-decorator'

import {IotMetricsServiceProxy, IotMetricsVo} from '@/service-proxies/app-v2/iot-console.service-proxies'

import moment from 'moment';
import './DailyOnline.less';
@Component
export default class Activation extends Vue {

    iotMetricsProxy = new IotMetricsServiceProxy();

    dateType = 1;

    dateRange=[moment().subtract(7,'d'), moment()];
    dateRangeModel=['date','date'];
    dateRangeFormat ='YYYY-MM-DD';


    option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        xAxis: {
            type: 'category',
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            data: []
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                // data: [120, 200, 150, 80, 70, 110, 130],
                data: [],
                label: {
                    show: true
                },
                type: 'bar'
            }
        ]
    };

    data=[];

    get sortData(){
        return this.data.sort((a,b)=> b.value-a.value).slice(0,6);
    }

    chart=undefined;

    mounted() {
        this.chart = (this as any).$echarts.init(
            this.$refs.chart
        );
        this.chart.setOption(this.option);
        this.initData();
    }

    initData(){
        const input = new IotMetricsVo();
        input.dateType= this.dateType;
        input.start= this.dateRange[0].toDate();
        input.end= this.dateRange[1].toDate();
        this.iotMetricsProxy.dataAmount(input)
            .then(res=>{
                this.data=res.itemList;
                this.chart.setOption(this.chartOption());
            });
    }

    chartOption(){
        return {
            xAxis: {
                data: this.data.map(c=>c.key)
            },
            series: [
                {
                    data: this.data.map(c=>c.value)
                }
            ]
        };
    }

    dateRangeChange(date, dateString){
        console.log('dateRangeChange');
        console.log('date', date);
        console.log('dateString', dateString);
    }


    dateTypeChange(){
        if(this.dateType===1){
            this.dateRangeModel=['date','date'];
            this.dateRangeFormat='YYYY-MM-DD';
        }else if(this.dateType===3){
            this.dateRangeModel=['month','month'];
            this.dateRangeFormat='YYYY-MM';
        }else if(this.dateType===5){
            this.dateRangeModel=['year','year'];
            this.dateRangeFormat='YYYY';
        }
        this.initData();
    }

    getDateRangeModel(){
        if(this.dateType===1){
            return ['date','date'];
        }else if(this.dateType===3){
            return ['month','month'];
        }
        return ['year','year'];
    }

    handlePanelChange2(value, mode) {
        console.log('mode', mode);
        this.dateRange = value;
        this.dateRangeModel =this.getDateRangeModel();
        // this.value = value;
        // this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
    }

    handleOpenChange(open) {
        if (!open) {
            this.initData();
        }
    }

    render() {
        return (
            <a-card class="iot-chart" title="采集量统计" style="width: 100%">
                <template slot="extra">
                    <a-radio-group size="small"
                                   v-model={this.dateType}
                                   button-style="solid"
                                   onChange={this.dateTypeChange}
                    >
                        <a-radio-button value={1}>
                            按日
                        </a-radio-button>
                        <a-radio-button value={3}>
                            按月
                        </a-radio-button>
                        <a-radio-button value={5}>
                            按年
                        </a-radio-button>
                    </a-radio-group>
                    <a-range-picker
                        mode={this.dateRangeModel}
                        format={this.dateRangeFormat}
                        onChange={this.initData}
                        onPanelChange={this.handlePanelChange2}
                        onOpenChange={this.handleOpenChange}
                        allowClear={false}
                        size="small"
                        v-model={this.dateRange}
                    >
                    </a-range-picker>
                </template>
                <a-row>
                    <a-col span="18">
                        <div ref="chart" style="width:100%;height:300px"></div>
                    </a-col>
                    <a-col span="6">
                        <h4 class="rankingTitle">
                            采集量排行
                        </h4>
                        <ul class="rankingList">
                            {
                                this.sortData.map((item,i)=>{
                                    return (<li>
                                        <span class={`rankingItemNumber ${i<3?'active':''}`}>{i+1}</span>
                                        <span class="rankingItemTitle">{item.key}</span>
                                        <span class="rankingItemValue">{item.value}</span>
                                    </li>);
                                })
                            }

                        </ul>
                    </a-col>
                </a-row>

            </a-card>
        )
    }
}
